import { render, staticRenderFns } from "./ProgramInfo.vue?vue&type=template&id=70313e76&scoped=true"
import script from "./ProgramInfo.vue?vue&type=script&lang=js"
export * from "./ProgramInfo.vue?vue&type=script&lang=js"
import style0 from "./ProgramInfo.vue?vue&type=style&index=0&id=70313e76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70313e76",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAutocomplete,VCol,VRow})
